import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogIn, X } from 'lucide-react';

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
  title?: string;
}

const LoginPromptModal: React.FC<LoginPromptModalProps> = ({
  isOpen,
  onClose,
  message = 'Sign in to interact with this content.',
  title = 'Sign In Required',
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!isOpen) return null;

  const handleLogin = () => {
    onClose();
    navigate('/login', { state: { from: location } });
  };

  const handleSignup = () => {
    onClose();
    navigate('/signup', { state: { from: location } });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl max-w-sm w-full mx-4 p-6 text-center">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-white transition-colors"
          style={{ position: 'absolute', top: '12px', right: '12px' }}
        >
          <X className="w-5 h-5" />
        </button>

        <div className="w-16 h-16 bg-orange-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <LogIn className="w-8 h-8 text-orange-400" />
        </div>

        <h3 className="text-xl font-semibold text-white mb-2">{title}</h3>
        <p className="text-gray-400 mb-6">{message}</p>

        <div className="space-y-3">
          <button
            onClick={handleLogin}
            className="w-full px-4 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors font-medium"
          >
            Sign In
          </button>
          <button
            onClick={handleSignup}
            className="w-full px-4 py-3 bg-gray-800 text-gray-300 rounded-lg hover:bg-gray-700 transition-colors font-medium"
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPromptModal;
